import script from "./AddonsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddonsPage.vue?vue&type=script&lang=ts&setup=true"

import "./AddonsPage.vue?vue&type=style&index=0&id=cb30cf1c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb30cf1c"]])

export default __exports__